module.exports = __webpack_public_path__ + "images/bannerIT-7817c645fb9a0b6907b8753c8af3b1c9.jpg";